export default function RotatingBadge({ className = "" }) {
  return (
    <div className={`spin-slow ${className}`} aria-hidden="true">
      <svg viewBox="0 0 120 120" className="h-full w-full drop-shadow-[0_8px_24px_rgba(0,0,0,0.18)]">
        <defs>
          <path
            id="badge-circle"
            d="M60,60 m-44,0 a44,44 0 1,1 88,0 a44,44 0 1,1 -88,0"
          />
        </defs>
        <circle cx="60" cy="60" r="58" fill="#1A1A1A" />
        <text
          fill="#F7F5F0"
          fontSize="10.5"
          letterSpacing="2.6"
          fontFamily="Manrope, sans-serif"
        >
          <textPath href="#badge-circle">
            EVERYDAY THINGS • MADE CLEVER • EASY MOOD •
          </textPath>
        </text>
        <path
          d="M60 46 L60 74 M46 60 L74 60 M50 50 L70 70 M70 50 L50 70"
          stroke="#D2968C"
          strokeWidth="4.5"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
